import "./series/create";
import "./series/series.js.coffee";
